import React from 'react';

import { BulkDownloadDocumentsView } from './BulkDownloadDocumentsView';

export const BulkDownloadFinanceDocumentsView: React.FC = () => {
  return (
    <BulkDownloadDocumentsView
      withProjectAttachments={false}
      withContracts={false}
      withAttachmentsTypes={false}
      filterOnlyCurrentUser={true}
      withoutCompany={true}
    />
  );
};
